/*
 *
 * Do not edit directly
 * Generated on Mon, 24 Jun 2024 16:18:26 GMT
 *
 */


const theme = {
  appearances: {},
  rules: [],
  tokens: {
    alignItems: 'stretch',
    flexGrow: 0,
    flexShrink: 0,
    justifyContent: 'flex-start',
    width: null
  }
}
export default theme
